// project
import { http } from "@/http";

export const getSessionCalendar = async(studyId:string):Promise<number[]> => {
	const { data } = await http.get(`studies/${studyId}/stats/session-calendar`);
	return data;
};